import party from '../views/party'

export default {
  path: '/party',
  component: party,
  redirect: '/party/member',
  name: 'Party',
  meta: { title: '商品管理' },
  children: [
    {
      path: '/party/member',
      component: () => import('@/views/party/Member'),
      name: 'Member',
      meta: { title: '商品列表' }
    },
    {
      path: '/party/stock',
      component: () => import('@/views/party/Stock'),
      name: 'Stock',
      meta: { title: '商品入库' }
    },
    {
      path: '/party/shmanage',
      component: () => import('@/views/party/shmanage'),
      name: 'shmanage',
      meta: { title: '产品管理' }
    }
  ]
}
